import { connect } from "react-redux";
import UserViewComponent from "./UserView.jsx";

// Local Actions
import { fetchUser } from "./duck/actions";

// Local Selectors
import { getUserDetails, isLoading } from "./duck/selectors"

const mapStateToProps = state => {
  return {
    user: getUserDetails(state),
    isLoading: isLoading(state)
  };
};

const mapDispatchToProps = {
  fetchUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserViewComponent);
